import i18n from 'services/base/i18n';

export default {
  // Button to save the changes to the parental control rules
  save: () => i18n.pgettext('Pages|Edit Parental Controls', 'SAVE'),
  // Placeholder text for the name of the parental control rule
  namePlaceholder: () => i18n.pgettext('Pages|Edit Parental Controls', 'Name of Rule'),
  // Label for the input that decides when this rule starts
  startTimeLabel: () => i18n.pgettext('Pages|Edit Parental Controls', 'START TIME'),
  // Label for the input that decides when this rule stops
  endTimeLabel: () => i18n.pgettext('Pages|Edit Parental Controls', 'END TIME'),
  // Label for the input that decides which days of the week this rule applies
  activeDaysLabel: () => i18n.pgettext('Pages|Edit Parental Controls', 'ACTIVE DAYS'),
  // Placeholder for the days of the week input box
  activeDaysPlaceholder: () => i18n.pgettext('Pages|Edit Parental Controls', 'Mon, Tue, Wed'),
  // Header of the section that lists the sites and apps that this parental control rule blocks
  blockedAppsLabel: () => i18n.pgettext('Pages|Edit Parental Controls', 'BLOCKED SITES & APPS'),
  // Text on a button to add new sites and apps to the block list
  blockedAppsPlaceholder: () => i18n.pgettext('Pages|Edit Parental Controls', 'Add Site'),
  // Header of the section that lists the devices that this rule applies to
  managedDevicesLabel: () => i18n.pgettext('Pages|Edit Parental Controls', 'MANAGED DEVICES'),
  // Text on a button to add a new device to the block list
  addDevicePlaceholder: () => i18n.pgettext('Pages|Edit Parental Controls', 'Add Device'),
  // Error displayed when the user tries to set an invalid name for the rule
  invalidName: () => i18n.pgettext('Pages|Edit Parental Controls', 'Invalid name'),
  // Error displayed when the rule doesn't apply to any day of the week
  invalidDays: () => i18n.pgettext('Pages|Edit Parental Controls', 'Invalid days of the week'),
};
